import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { TableRow, TableCell } from "@mui/material";
import dayjs from "dayjs";
import "dayjs/locale/th";
import utils from "../../../../../../utils";

const StyledTableRow = styled(TableRow)({
  marginBottom: 4,
  marginTop: 8,
});

const StyledTableCell = styled(TableCell)({
  padding: 0,
  border: "none",
  "& .wrap": {
    height: 72,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    borderTop: "1px solid #e1e1e1",
    borderLeft: "1px solid #e1e1e1",
    borderBottom: "1px solid #e1e1e1",
    "&.first": {
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
    },
    "&.last": {
      borderTopRightRadius: 8,
      borderBottomRightRadius: 8,
      borderRight: "1px solid #e1e1e1",
    },
  },
  "&.date-document": {
    width: 130,
    "& .MuiInputBase-root": {
      paddingRight: 8,
    },
  },
  "&.service": {
    width: 150,
  },
  "&.description": {
    width: 200,
  },
  "&.amount": {
    width: 104,
  },
  "&.price": {
    width: 104,
  },
  "&.discount": {
    width: 104,
  },
  "&.tax": {
    width: 60,
  },
  "&.price-before-tax": {
    width: 104,
  },
  "&.tax-withholding": {
    width: 104,
  },
});

const RowItemExpense = (props) => {
  const { index, count, data } = props;

  return (
    <StyledTableRow>
      <StyledTableCell className="date-document">
        <div className="wrap first">
          {dayjs(data.documentDate).format("DD/MM/BBBB")}
        </div>
      </StyledTableCell>
      <StyledTableCell className="cell-table service">
        <div className="wrap">{data.service}</div>
      </StyledTableCell>
      <StyledTableCell className="cell-table description">
        <div className="wrap">{data.description}</div>
      </StyledTableCell>
      <StyledTableCell className="cell-table amount">
        <div className="wrap">
          {utils.numberWithCommas(parseFloat(data.amount))}
        </div>
      </StyledTableCell>
      <StyledTableCell className="cell-table price">
        <div className="wrap">
          {utils.numberWithCommas(parseFloat(data.unitPrice))}
        </div>
      </StyledTableCell>
      <StyledTableCell className="cell-table tax" align="center">
        <div className="wrap">{data.taxPercent}%</div>
      </StyledTableCell>
      <StyledTableCell className="cell-table price-before-tax">
        <div className="wrap">
          {utils.numberWithCommas(parseFloat(data.total))}
        </div>
      </StyledTableCell>
      <StyledTableCell className="cell-table tax-withholding">
        <div className="wrap last">{data.withholdingPercent}%</div>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default RowItemExpense;
